// removed by extract-text-webpack-plugin
module.exports = {"modalContainer":"style__modalContainer___321-j","inner":"style__inner___QAYI2","logo":"style__logo___1EUUL"};


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/layout/ui/components/loader-processing/style.css
// module id = 1136
// module chunks = 0